<template>
  <div class="platform-value">
    <app-header></app-header>

    <!-- 轮播图 -->
    <div class="swiper-box">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="(slide, index) in carouselSlides" :key="index">
          <img :src="slide.bgImage" alt="" />
          <div class="slide-content">
            <div class="container">
              <div class="slide-text-content">
                <p class="slide-en-title">{{ slide.enTitle }}</p>
                <h1 class="slide-title">{{ slide.title }}</h1>
              </div>
            </div>
          </div>
        </swiper-slide>

        <!-- 小圆点 -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <!-- 渠道数字化搭建方案 -->
    <section class="section section01">
      <div class="container">
        <h2 class="section-title">渠道数字化搭建方案</h2>
        <div class="flexBox">
          <div class="item">
            <div class="icon icon1"></div>
            <h3 class="tag">组织架构搭建</h3>
          </div>
          <div class="item">
            <div class="icon icon2"></div>
            <h3 class="tag">区域划分与权限设置</h3>
          </div>
          <div class="item">
            <div class="icon icon3"></div>
            <h3 class="tag">绑定关系与防串货体系建设</h3>
          </div>
        </div>
      </div>
    </section>

    <!-- 终端全量开发方案 -->
    <section class="section section02 section-gray">
      <div class="container">
        <h2 class="section-title">终端全量开发方案</h2>
        <div class="flexBox">
          <div class="item">
            <div class="icon icon1"></div>
            <h3 class="tag tag1">药店、诊所、民营医院标准化开发</h3>
          </div>
          <div class="item">
            <div class="icon icon2"></div>
            <h3 class="tag tag2">一店一码、一人一区、精准覆盖</h3>
          </div>
          <div class="item">
            <div class="icon icon3"></div>
            <h3 class="tag tag3">终端档案数字化管理</h3>
          </div>
        </div>
      </div>
    </section>

    <!-- 团队管理与考核方案 -->
    <section class="section section03 section-white">
      <div class="container">
        <h2 class="section-title">团队管理与考核方案</h2>
        <div class="flexBox">
          <div class="background">
            <div class="centerPoint">
              <div class="point point1">团队长准入、考核留存机制</div>
              <div class="point point2">业务员目标、过程结果三位一体管理</div>
              <div class="point point3">自动核算、透明分润长期激励</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 有序营销与合规方案 -->
    <section class="section section04 section-gray">
      <div class="container">
        <h2 class="section-title">有序营销与合规方案</h2>
        <div class="flexBox">
          <div class="item">
            <div class="icon icon1"></div>
            <h3 class="tag tag1">区域保护、货流可溯行为可监</h3>
          </div>
          <div class="item">
            <div class="icon icon2"></div>
            <h3 class="tag tag2">杜绝串货、乱价、恶意竞争</h3>
          </div>
          <div class="item">
            <div class="icon icon3"></div>
            <h3 class="tag tag3">构建良性、健康、可复制的渠道模式</h3>
          </div>
        </div>
      </div>
    </section>

    <!-- 圆图 -->
    <section class="section section05 section-white">
      <div class="container">
        <div class="flexBox">
          <img class="image" src="@/assets/Solution/icon11.png" alt="" />
        </div>
      </div>
    </section>

    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'

export default {
  name: 'SolutionPage',
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      swiperOptions: {
        // 👇 最常用配置（直接用）
        loop: true, // 无限循环
        // autoplay: false,
        autoplay: {
          delay: 3000, // 3秒切换一次
          disableOnInteraction: false, // 滑动后不停止自动轮播
          pauseOnMouseEnter: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true, // 小圆点可点击
        },
        speed: 600, // 切换速度
        slidesPerView: 1, // 一屏显示几张
        spaceBetween: 0, // 图片间距
        effect: 'slide',
      },
      carouselSlides: [
        {
          bgImage: require('@/assets/Solution/banner01.png'),
          enTitle: 'Comprehensive solution for refined market operation',
          title: '医药广阔市场精细化运营整体解决方案',
        },
        {
          bgImage: require('@/assets/Solution/banner01.png'),
          enTitle: 'Comprehensive solution for refined market operation',
          title: '医药广阔市场精细化运营整体解决方案',
        },
        {
          bgImage: require('@/assets/Solution/banner01.png'),
          enTitle: 'Comprehensive solution for refined market operation',
          title: '医药广阔市场精细化运营整体解决方案',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.platform-value {
  padding-top: 80px;
}

.section-title {
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-style: normal;
  font-size: 40px;
  line-height: 53px;
  height: 53px;
  letter-spacing: 0;
  color: #000000;
  text-align: center;
  margin: 0;
}

/* 轮播图样式 */
.swiper-box {
  width: 100%;
  height: 800px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.slide-content {
  position: absolute;
  top: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.swiper-container) {
  height: 100%;
}
:deep(.swiper-pagination-bullet) {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ffffff;
  margin: 0 18px !important;
  opacity: 1 !important;
  &.swiper-pagination-bullet-active {
    border-radius: 5px 5px 5px 5px;
    width: 56px;
  }
}
.slide-text-content {
  text-align: center;
  color: #fff;
}

.slide-en-title {
  font-size: 24px;
  color: #fff;
  margin-bottom: 20px;
  letter-spacing: 2px;
  opacity: 0.9;
  text-transform: uppercase;
}

.slide-title {
  font-size: 64px;
  color: #fff;
  font-weight: bold;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

/* 团队长端（微信小程序） */
.section {
  background: linear-gradient(180deg, #1ca19630 0%, #ffffff 100%);
  height: 821px;
  &.section-white {
    background: #ffffff !important;
  }
  &.section-gray {
    background: #f5f5f5 !important;
  }
  .content {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .image {
      width: 376px;
      height: 376px;
      border-radius: 20px;
      box-shadow: 0px 4px 16px 0px #1ca19640;
    }
    dl {
      padding: 0;
      dt {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-style: normal;
        font-size: 30px;
        letter-spacing: 0;
        color: #000000;
        line-height: 40px;
        height: 40px;
        margin-bottom: 40px;
      }
      dd {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-style: normal;
        font-size: 20px;
        letter-spacing: 0;
        line-height: 26px;
        height: 26px;
        margin: 0;
        margin-bottom: 28px;
        &::before {
          content: '';
          width: 12px;
          height: 12px;
          display: inline-block;
          background: #1ca196;
          border-radius: 50%;
          margin-right: 19px;
        }
      }
    }
  }
}

.section-right {
  background-color: #f5f5f5;
  dl {
    margin: 0;
    margin-left: 121px;
  }
  .image {
    margin-left: 0;
  }
}

/* 业务员端（微信小程序） */
.section-left {
  background-color: #f5f5f5;
  dl {
    margin: 0;
    margin-left: 0;
  }
  .image {
    margin-left: 121px;
  }
}

/* 渠道数字化搭建方案 */
.section01 {
  height: 650px;
  display: flex;
  justify-content: center;
  align-items: center;
  .section-title {
    margin-bottom: 112px;
  }
  .flexBox {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 220px;
    .item {
      width: 120px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .icon {
        width: 100px;
        height: 100px;
        border-radius: 20px;
        margin-bottom: 28px;
        &.icon1 {
          background: url('@/assets/Solution/icon01.png') no-repeat center 58%, linear-gradient(180deg, #c2e5e2 0%, #73b9b3 100%);
        }
        &.icon2 {
          background: url('@/assets/Solution/icon02.png') no-repeat center 58%, linear-gradient(180deg, #c2e5e2 0%, #73b9b3 100%);
        }
        &.icon3 {
          background: url('@/assets/Solution/icon03.png') no-repeat center 58%, linear-gradient(180deg, #c2e5e2 0%, #73b9b3 100%);
        }
      }
      .tag {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-style: normal;
        font-size: 20px;
        line-height: 26px;
        height: 26px;
        margin: 0;
        letter-spacing: 0;
        text-align: center;
      }
    }
  }
}

/* 终端全量开发方案 */
.section02 {
  height: 705px;
  padding-top: 125px;
  padding-bottom: 158px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  .section-title {
    margin-bottom: 86px;
  }
  .flexBox {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 110px;
    .item {
      width: 230px;
      height: 284px;
      display: flex;
      align-items: center;
      flex-direction: column;
      border-radius: 20px;
      background: #ffffff;
      overflow: hidden;
      .icon {
        width: 100%;
        height: 200px;
        margin-bottom: 14px;
        &.icon1 {
          background: url('@/assets/Solution/icon04.png') no-repeat center center;
          background-size: 100% 100%;
        }
        &.icon2 {
          background: url('@/assets/Solution/icon05.png') no-repeat center center;
          background-size: 100% 100%;
        }
        &.icon3 {
          background: url('@/assets/Solution/icon06.png') no-repeat center center;
          background-size: 100% 100%;
        }
      }
      .tag {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-style: normal;
        font-size: 20px;
        line-height: 26px;
        height: 26px;
        margin: 0;
        letter-spacing: 0;
        text-align: center;
        &.tag1 {
          width: 160px;
        }
        &.tag2 {
          width: 140px;
        }
        &.tag3 {
          width: 120px;
        }
      }
    }
  }
}

/* 团队管理与考核方案 */
.section03 {
  padding: 110px 0 119px;
  height: 935px;
  box-sizing: border-box;
  .section-title {
    margin-bottom: 156px;
  }
  .flexBox {
    display: flex;
    justify-content: center;
    align-items: center;
    .background {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 420px;
      width: 474px;
      background: url('@/assets/Solution/icon07.png') no-repeat center;
      background-size: 100% auto;
      .centerPoint {
        position: relative;
        .point {
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-style: normal;
          font-size: 20px;
          line-height: 26px;
          letter-spacing: 0;
          text-align: center;
        }
        .point1 {
          position: absolute;
          left: 0;
          top: -279px;
          width: 160px;
          line-height: 26px;
          transform: translateX(-50%);
        }
        .point2 {
          position: absolute;
          left: 0;
          width: 160px;
          top: 227px;
          transform: translateX(-272px);
        }
        .point3 {
          position: absolute;
          left: 0;
          width: 180px;
          top: 227px;
          transform: translateX(98px);
        }
      }
    }
  }
}

/* 有序营销与合规方案 */
.section04 {
  height: 706px;
  padding-top: 108px;
  padding-bottom: 145px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  .section-title {
    margin-bottom: 86px;
  }
  .flexBox {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 110px;
    .item {
      width: 230px;
      height: 284px;
      padding-top: 53px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      flex-direction: column;
      border-radius: 20px;
      background: #ffffff;
      overflow: hidden;
      .icon {
        width: 115px;
        height: 116px;
        margin-bottom: 38px;
        &.icon1 {
          background: url('@/assets/Solution/icon08.png') no-repeat center center;
          background-size: 100% 100%;
        }
        &.icon2 {
          background: url('@/assets/Solution/icon09.png') no-repeat center center;
          background-size: 100% 100%;
        }
        &.icon3 {
          background: url('@/assets/Solution/icon10.png') no-repeat center center;
          background-size: 100% 100%;
        }
      }
      .tag {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-style: normal;
        font-size: 20px;
        line-height: 26px;
        height: 26px;
        margin: 0;
        letter-spacing: 0;
        text-align: center;
        width: 180px;
      }
    }
  }
}

.section05 {
  height: 915px;
  padding-top: 107px;
  padding-bottom: 117px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  .image {
    display: block;
    width: auto;
    height: 693px;
    margin: auto;
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
}

@media (max-width: 768px) {
}
</style>
